export const getOrdersDataState = (store) => store.OrdersReducer;
export const getSettingDataState = (store) => store.settingReducer;
